import {getId} from 'apis/model/base'
import classNames from 'classnames'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import createSearchResultComponent from 'views/Discovery/functions/createSearchResultComponent'
import {participant_status_options} from '..'
import getLinkToDetail from '../../../../helpers/getLinkToDetail'
import {renderIf, renderIfElse} from '../../../Shared'
import {GenderTypes} from "../../appFieldTypes";
import {BiSolidMapPin} from "react-icons/bi";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {RiMapPinTimeFill, RiUser2Fill} from "react-icons/ri";
import {ItemInformation} from 'components/common/ItemInformation'
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {GoDotFill} from "react-icons/go";
import {renderFromToTime} from "../../../../helpers/datetimeHelpers";
import {Avatar} from "antd";
import getAvatar from "../../../../helpers/getAvatar";
import getAliasName from "../../../../helpers/getAliasName";
import {convertStringToDate} from "../../../../helpers/dateUtils";

const EventInfo = ({item}) => (
    <div className="w-full">{createSearchResultComponent(item, getId(item))}</div>
)

export const renderEventParticipant =
    ({renderContextMenu} = {}) =>
        (item, index) => {
            const {owner, status} = item ?? {}
            const {
                title,
                time_open,
                time_close,
                event_type,
                location_name,
                external_link,
            } = owner ?? {}

            const status_options = Object.values(participant_status_options)
            const current_status = _.find(status_options, {value: status}) ?? {}
            const {isSm} = useContext(LayoutContext)

            return (
                <Translate key={index}>
                    {(t) => (
                        <div
                            className="w-full p-3 flex flex-col gap-2 background border-t border-color-50 shadow-md hover:scale-2xs rounded-xl cursor-pointer custom-item-render relative">
                            <div style={{fontSize: isSm ? 13 : 15}} className="space-x-2 leading-snug mr-8 md:mr-0">
                                <span className="font-medium text-gray-800 italic whitespace-no-wrap">
                                    {t('you have registered to attend the event')}
                                </span>
                                <Link
                                    to={getLinkToDetail(owner)}
                                    className="font-semibold text-green-500 no-underline">
                                    {title}
                                </Link>
                            </div>
                            <div className="flex flex-col gap-1 flex-1">
                                <div className="flex flex-col md:flex-row md:items-center gap-x-3 md:gap-x-6 gap-y-1">
                                    <ItemInformation
                                        showIcon={true}
                                        label="type of event"
                                        value={t(event_type)}
                                        className="text-xs italic"
                                    />
                                    <div className="flex items-center gap-1 text-xs italic">
                                        {renderIfElse(
                                            isSm,
                                            <RiMapPinTimeFill size={12} className="text-color-500"/>,
                                            <GoDotFill size={10} className="text-color-500"/>
                                        )}
                                        {renderIf(
                                            !isSm,
                                            <span className="text-xs text-color-500 italic">
                                    {`${t('time takes place')} : `}
                                </span>
                                        )}
                                        <span className="font-semibold text-color-100 leading-tight">
                                {renderFromToTime(time_open, time_close)}
                            </span>
                                    </div>
                                </div>
                                <div className="flex items-center gap-1 text-xs italic">
                                    {renderIfElse(
                                        isSm,
                                        <BiSolidMapPin size={12} className="text-color-500"/>,
                                        <GoDotFill size={10} className="text-color-500"/>
                                    )}
                                    {renderIf(
                                        !isSm,
                                        <span className="text-color-500 whitespace-no-wrap">
                                {`${t('address')} : `}
                            </span>
                                    )}
                                    <span className="font-semibold text-color-100 leading-tight">
                            {location_name}
                        </span>
                                </div>
                                {renderIf(
                                    external_link,
                                    <ItemInformation showIcon={true} label="link" value={external_link} className="text-xs italic leading-tight"/>
                                )}
                            </div>
                            {renderIf(
                                status !== 1,
                                <span
                                    style={{position: 'absolute', top: 30, right: 5, padding: '2px 8px', fontSize: 10}}
                                    className={classNames('w-fit flex items-center gap-2 rounded-full font-medium italic leading-tight', current_status?.className)}>
                                    {t(current_status?.label)}
                                </span>
                            )}
                            {_.isFunction(renderContextMenu) && (
                                <div style={{top: 5, right: 5}} className="absolute contextIcon">
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )
        }

export const renderRegistrationParticipant = ({renderContextMenu} = {}) => (item, index) => {
    const {
        user,
        name,
        owner,
        status,
        gender,
        date_of_birth,
        contact_phone,
        contact_email,
        registration_date,
    } = item ?? {}

    const {title} = owner ?? {}

    const status_options = Object.values(participant_status_options)
    const current_status = _.find(status_options, {value: status}) ?? {}
    const labelGender = _.find(GenderTypes, {value: gender})?.label
    const birthday = date_of_birth ? convertStringToDate(date_of_birth).format('DD/MM/YYYY') : null

    return (
        <LayoutContext.Consumer>
            {({isSm}) => (
                <Translate key={index}>
                    {(t) => (
                        <div
                            className="w-full flex flex-col gap-1 py-2 custom-render-border custom-item-render relative ">
                            <div className="flex items-center gap-2">
                                <Avatar
                                    src={getAvatar(user)}
                                    icon={<RiUser2Fill size={16} className="text-color-500"/>}
                                    className="flex flex-center background-200"
                                />
                                <div className="flex items-baseline gap-1 text-sm">
                                  <span className="font-medium text-color-100 italic">
                                      {getAliasName(user, 'patron_saint')}
                                  </span>
                                    <Link to={getLinkToDetail(user)} className="font-bold text-color-000 no-underline">
                                        {name}
                                    </Link>
                                    <span className="text-color-300 italic lowercase">
                                      {t('sign up for this event')}
                                  </span>
                                </div>
                            </div>
                            <div className="ml-0 md:ml-3 flex flex-col gap-1">
                                {renderIf(
                                    _.some([contact_phone, contact_email]),
                                    <DoubleValueItem
                                        showIcon={true}
                                        labelFirst={!isSm && 'contact'}
                                        valueFirst={contact_phone}
                                        labelSecond={contact_email ? ' - ' : ''}
                                        valueSecond={contact_email}
                                        className="text-xs italic"
                                    />
                                )}
                                {renderIf(
                                    _.some([birthday, gender !== 0]),
                                    <DoubleValueItem
                                        showIcon={true}
                                        labelFirst={!isSm && 'date of birth'}
                                        valueFirst={birthday}
                                        labelSecond={gender !== 0 ? ' - ' : ''}
                                        valueSecond={t(labelGender)}
                                        className="text-xs italic"
                                    />
                                )}
                            </div>
                            <div style={{bottom: 8, right: 8, position: 'absolute'}}>
                              <span
                                  style={{padding: '2px 10px 2px 8px'}}
                                  className={classNames(
                                      'w-fit flex items-center gap-2 rounded-full leading-tight',
                                      current_status?.className
                                  )}>
                                    {current_status?.icon}
                                  {renderIf(
                                      _.isString(current_status?.label),
                                      <span className="font-medium text-xs italic">
                                          {t(current_status?.label)}
                                      </span>
                                  )}
                                </span>
                            </div>
                            {_.isFunction(renderContextMenu) && (
                                <div
                                    style={{top: 5, right: 5}}
                                    className="absolute contextIcon">
                                    {renderContextMenu(item)}
                                </div>
                            )}
                        </div>
                    )}
                </Translate>
            )}
        </LayoutContext.Consumer>

    )
}
